<template>
    <main class="main">

        <div class="header-image"></div>

        <About ref="about"></About>

        <Numbers></Numbers>

        <Members ref="board"></Members>

        <VesselsByType ref="fleet"></VesselsByType>

        <Clients ref="clients"></Clients>

        <div class="main-image"></div>

        <Locations ref="contacts"></Locations>

        <Policy ref="policy" type="policy" :visible="policyVisible" v-on:togglePolicy="$emit('togglePolicy', $event)">
        </Policy>

        <Policy ref="shipRecycling" type="shipRecycling" :visible="shipRecyclingVisible"
            v-on:toggleShipRecycling="$emit('toggleShipRecycling', $event)"></Policy>

    </main>
</template>

<script>
import About from "./main/About.vue";
import VesselsByType from "./main/VesselsByType.vue";
import Clients from "./main/Clients.vue";
import Members from "./main/Members.vue";
import Locations from "./main/Locations.vue";
import Policy from "./main/Policy.vue";
import Numbers from './main/Numbers.vue';

export default {
    name: "Main",
    props: ["policyVisible", "shipRecyclingVisible"],
    components: {
        About,
        VesselsByType,
        Clients,
        Members,
        Locations,
        Policy,
        Numbers
    },
    data() {
        return {
        }
    },
    methods: {
        navigate() {
            let angkor = this.$route.params.angkor,
                comp = this.$refs[angkor],
                element, top;

            if (comp) {
                element = comp.$el;
                setTimeout(() => {
                    top = element.offsetTop;
                    window.scrollTo(0, top);
                }, 100);
            } else {
                window.scrollTo(0, 0);
            }
        }
    },
    mounted() {
        this.navigate();
    },
    watch: {
        $route() {
            this.navigate();
        }
    }
}
</script>

<style>
.main {
    margin-top: 5em;
    position: relative;
}

.main.lower {
    margin-bottom: -500px;
}

.main.loading {
    height: calc(100vh - 5em);
    overflow: hidden;
}

.section {
    padding-top: 1.5em;
    padding-bottom: 1em;
}

.section .container .row {
    position: relative;
}

.section-blue {
    background-color: #26828E;
    color: #FFF;
}

.section-gray {
    background-color: #f0f0f0;
}

.section a.target {
    position: absolute;
    left: 0px;
    top: -6.5em;
}

.section-heading {
    font-weight: 400;
    color: #144378;
    padding-bottom: 1.2em;
}

.section-heading-white {
    color: #FFF;
}

@media only screen and (min-width: 400px) {
    .main {
        margin-top: 6.3em;
    }

    .main.loading {
        height: calc(100vh - 6.3em);
        overflow: hidden;
    }

    .section a.target {
        top: -7.7em;
    }
}

@media only screen and (min-width: 576px) {
    .section {
        padding-top: 5em;
        padding-bottom: 4em;
    }

    .section a.target {
        top: -11.3em;
    }
}

@media only screen and (min-width: 992px) {
    .section-heading {
        font-size: 2.5em;
    }
}
</style>